import { render, staticRenderFns } from "./RsaPazientePaiDomiciliareListComponent.vue?vue&type=template&id=6629a602&scoped=true"
import script from "./RsaPazientePaiDomiciliareListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePaiDomiciliareListComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePaiDomiciliareListComponent.vue?vue&type=style&index=0&id=6629a602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6629a602",
  null
  
)

export default component.exports